import { GraphQL } from '@guestgoodie/graphql'

import { useLayout } from '../hooks/useLayouts'
import LayoutDetail from './LayoutDetail'

import { Permission, useCheckPermission } from '@/features/auth'
import { LayoutHeader } from './LayoutHeader'

interface Props {
  categorySlug?: string
  layoutVersion?: number
}

export default function Layout({ categorySlug, layoutVersion }: Props) {
  const canUpdateLayout = useCheckPermission([Permission.LAYOUT_UPDATE])
  const layout = useLayout(layoutVersion)

  return (
    <div className="flex flex-col gap-4 pr-4">
      <LayoutHeader layout={layout} canUpdateLayout={canUpdateLayout} />
      {layout && (
        <LayoutDetail
          layout={layout}
          categorySlug={categorySlug}
          readOnly={
            layout.state !== GraphQL.LayoutState.Draft || !canUpdateLayout
          }
        />
      )}
    </div>
  )
}
